import type { FrontendNavigationItem, NavigationVisit } from "~/stores/navigationVisits";

export const useNavigationVisits = () => {
    const client = useSanctumClient();
    const user = useSanctumUser();
    const store = useNavigationVisitsStore();

    const loadVisits = async () => {
        if (!user.value || store.visits) {
            return;
        }

        try {
            const data = await client<NavigationVisit[]>("/api/navigation/visits");
            store.setVisits(data);
        } catch {
            // Non-critical "new" badge data, swallow network failures instead of surfacing as unhandled errors
        }
    };

    const trackVisit = async (navItem: FrontendNavigationItem) => {
        if (!user.value) {
            return;
        }

        store.markVisited(navItem);

        const data = await client<NavigationVisit[]>("/api/navigation/visit", {
            method: "POST",
            body: { nav_item: navItem },
        });
        store.setVisits(data);
    };

    const isNewVisit = (item: FrontendNavigationItem) => {
        if (!store.visits) {
            return false;
        }

        return store.visits[item]?.new ?? false;
    };

    return {
        visits: store.visits,
        loadVisits,
        trackVisit,
        isNewVisit,
    };
};
